import BaseApiService from './BaseApiService';

class OrderHistoryApiService extends BaseApiService {
  getMyOrders(params) {
    return this.getAxiosInstance().get('/order/my-orders', { params });
  }
}

export default new OrderHistoryApiService(); 